export const convertSalaryUnits = (type: string): string => {
    switch (type) {
        case 'Annual':
            return 'YEAR';
        case 'Daily':
            return 'DAY';
        case 'Hourly':
            return 'HOUR';
        default:
            return 'YEAR';
    }
}

export const convertJobType = (type: string): string => {
    switch (type) {
        case 'Permanent':
            return 'FULL_TIME';
        case 'Contract':
            return 'CONTRACTOR';
        case 'Temporary':
            return 'PART_TIME';
        default:
            return 'FULL_TIME';
    }
}

export const convertJobAddress = (locationMeta: any) => {
    const retVal: any = {
        "@type": "PostalAddress"
    };

    if(!locationMeta?.address_components) {
        return {};
    }

    const streetAddressComponent = locationMeta.address_components.find(component => component.types.includes('street_address'));
    const routeComponent         = locationMeta.address_components.find(component => component.types.includes('route'));
    const localityComponent      = locationMeta.address_components.find(component => component.types.includes('locality'));
    const regionComponent        = locationMeta.address_components.find(component => component.types.includes('postal_town'));
    const adminLevel2Component   = locationMeta.address_components.find(component => component.types.includes('administrative_area_level_2'));
    const postcodeComponent      = locationMeta.address_components.find(component => component.types.includes('postal_code'));
    const countryComponent       = locationMeta.address_components.find(component => component.types.includes('country'));

    if(locationMeta?.formatted_address || streetAddressComponent?.long_name || routeComponent?.long_name) {
        retVal.streetAddress = locationMeta?.formatted_address || streetAddressComponent?.long_name || routeComponent?.long_name;
    }

    if(localityComponent?.long_name) {
        retVal.addressLocality = localityComponent.long_name;
    }
    
    if(adminLevel2Component?.long_name || regionComponent?.long_name) {
        retVal.addressRegion = adminLevel2Component?.long_name || regionComponent?.long_name;
    }
    if (postcodeComponent?.long_name) {
        retVal.postalCode = postcodeComponent.long_name;
    }

    if(countryComponent?.long_name) {
        retVal.addressCountry  = countryComponent.long_name;
    }

    return retVal;
}

/**
 * Human readable string for salary
 * @param salary
 * @returns {String}
 */
export const salaryString = (salary) => {
    return `From £${salary.from} to £${salary.to} ${salary.type}`;
}